var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#F2F5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0059,
    y: 17.629,
    width: 27.9612,
    height: 18.612,
    rx: 1,
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2188 42.4451H40.7527",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3255 36.2411V42.4451",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6458 36.2411V42.4451",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2687 27.9807L38.8291 29.2036L38.3691 23.6478L36.0469 25.2997",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7155 23.6554C34.2124 23.6114 34.707 23.7597 35.1003 24.0708C35.4936 24.3818 35.7559 24.8322 35.8342 25.3314L36.0399 27.7338C36.0628 27.9961 36.0343 28.2603 35.9564 28.5116C35.8784 28.7628 35.7523 28.9961 35.5852 29.1977C35.418 29.3993 35.2136 29.5658 34.983 29.6871C34.7524 29.8085 34.5001 29.8826 34.2414 29.905L29.4852 30.3065C29.2261 30.3305 28.965 30.3024 28.7167 30.2238C28.4688 30.1448 28.2382 30.017 28.0394 29.8476C27.8401 29.6782 27.6758 29.4701 27.5565 29.236C27.4372 29.0018 27.3645 28.7461 27.3432 28.4835L27.1527 26.2439C27.129 25.9813 27.1568 25.7166 27.2343 25.4654C27.3122 25.2137 27.438 24.98 27.6055 24.7785C27.7726 24.5765 27.9775 24.4099 28.2085 24.289C28.4399 24.1681 28.6922 24.0944 28.9513 24.0728L33.7155 23.6554Z",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7464 43.1188C53.6056 43.4459 53.398 43.7395 53.136 43.9828C52.8741 44.2261 52.5633 44.4146 52.2215 44.5373C51.8788 44.6599 51.5125 44.7137 51.1429 44.6963C50.773 44.6795 50.4069 44.5909 50.0668 44.4363C49.7257 44.2819 49.4173 44.0644 49.1581 43.7969C48.8992 43.5287 48.6945 43.2162 48.5572 42.876C48.4199 42.5357 48.3518 42.1761 48.357 41.8161C48.362 41.4564 48.4404 41.1043 48.5872 40.7799L50.2362 37.0447C50.5299 36.3972 51.0791 35.8998 51.7646 35.6609C52.4509 35.4225 53.217 35.4614 53.8975 35.77C54.5774 36.0781 55.1168 36.6311 55.3974 37.3079C55.6779 37.9847 55.6771 38.7307 55.3953 39.3836L53.7464 43.1188Z",
    fill: "#F05A28",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8173 37.8607L46.9847 39.6989C46.7291 40.2642 46.586 40.8734 46.5628 41.4906C46.5396 42.1078 46.6375 42.7219 46.8507 43.2967C47.0629 43.8718 47.3878 44.3971 47.8034 44.8428C48.2201 45.2881 48.7209 45.6453 49.2772 45.8933C49.8345 46.1411 50.4355 46.2755 51.0475 46.2884C51.6598 46.3007 52.2702 46.1922 52.8447 45.9678C53.4186 45.7431 53.9455 45.4077 54.3943 44.98C54.8431 44.5524 55.206 44.0415 55.4616 43.4761L56.2941 41.6379",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4922 46.0475L48.2977 49.2095",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5742 48.8535L50.2224 50.325",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1713 39.8522C16.9327 40.0802 16.6317 40.2325 16.3064 40.2899C15.9812 40.3472 15.6461 40.3071 15.3437 40.1744C15.0413 40.0417 14.7851 39.8225 14.6075 39.5445C14.4299 39.2665 14.339 38.9422 14.3461 38.6125C14.3532 38.283 14.4582 37.9629 14.6476 37.6928C14.837 37.4227 15.1024 37.2147 15.4103 37.0952C15.7182 36.9757 16.0547 36.95 16.3772 37.0212C16.6997 37.0926 16.9938 37.2578 17.2223 37.4959C17.5276 37.8156 17.6935 38.243 17.684 38.6845C17.6744 39.1261 17.4901 39.5459 17.1713 39.8522Z",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7846 29.8517C52.546 30.0797 52.245 30.232 51.9197 30.2894C51.5944 30.3467 51.2594 30.3066 50.957 30.1739C50.6546 30.0412 50.3983 29.822 50.2208 29.544C50.0432 29.266 49.9522 28.9417 49.9594 28.612C49.9665 28.2825 50.0714 27.9624 50.2609 27.6923C50.4503 27.4222 50.7157 27.2142 51.0236 27.0947C51.3315 26.9752 51.668 26.9495 51.9905 27.0208C52.313 27.0921 52.6071 27.2573 52.8356 27.4954C53.1408 27.8151 53.3068 28.2425 53.2972 28.6841C53.2877 29.1256 53.1034 29.5454 52.7846 29.8517Z",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.207 18.4608L16.304 26.795L21.5375 20.1155L13.207 18.4608Z",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5232 23.1721L29.5 22.8698V28.8698L33.1636 24.8398C33.7163 24.2319 33.3407 23.2538 32.5232 23.1721Z",
    fill: "#F05A28",
    stroke: "#014935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallIcon);
export default __webpack_public_path__ + "static/media/video-call-icon.a3057831a1ec4997162f2eef5a74c239.svg";
export { ForwardRef as ReactComponent };